import * as React from "react";
const SvgDispatchPlanOutlined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M18 3c.55 0 1 .45 1 1v1h.56a2.01 2.01 0 0 1 1.9 1.37l1.44 4.32c.07.21.1.42.1.63V18h-3c0 1.66-1.34 3-3 3s-3-1.34-3-3h-4c0 1.66-1.34 3-3 3s-3-1.34-3-3H3c-1.1 0-2-.9-2-2v-5h11V7c0-1.1.9-2 2-2h2V4c0-.55.45-1 1-1zM7 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m10 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1M3 13v3h1.78c.55-.61 1.33-1 2.22-1s1.67.39 2.22 1H12v-3zm11 0v3h.78c.55-.61 1.34-1 2.22-1s1.67.39 2.22 1H21v-3zm0-6v4h6.89l-1.33-4zm-3-2v1.5h-1v2h1V10H1V8.5h1v-2H1V5zM3.5 6.5v2h1.75v-2zm3.25 0v2H8.5v-2z"
    />
  </svg>
);
export default SvgDispatchPlanOutlined;
